<template>
  <div class="support-page">
    <div class="page-header">
      <div class="container">
        <h1>技术支持</h1>
        <div class="breadcrumb">首页 > 技术支持</div>
      </div>
    </div>
    <div class="container">
      <div class="section">
        <div class="section-title">
          <h2>技术支持与服务</h2>
          <p>我们提供全方位的技术支持，确保您的系统稳定运行</p>
        </div>
        <div class="support-content">
          <div class="support-tabs">
            <el-tabs type="border-card">
              <el-tab-pane label="常见问题">
                <div class="faq-list">
                  <div class="faq-item">
                    <div class="faq-question">
                      <h3>问题1：产品使用过程中常见问题</h3>
                    </div>
                    <div class="faq-answer">
                      <p>这里是问题的详细解答。这里是问题的详细解答。这里是问题的详细解答。这里是问题的详细解答。这里是问题的详细解答。</p>
                    </div>
                  </div>
                  <div class="faq-item">
                    <div class="faq-question">
                      <h3>问题2：系统安装与配置问题</h3>
                    </div>
                    <div class="faq-answer">
                      <p>这里是问题的详细解答。这里是问题的详细解答。这里是问题的详细解答。这里是问题的详细解答。这里是问题的详细解答。</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="下载中心">
                <p>请联系客服获取最新的产品文档和软件更新。</p>
              </el-tab-pane>
              <el-tab-pane label="联系支持">
                <div class="contact-support">
                  <p>如您在使用过程中遇到任何问题，请通过以下方式联系我们的技术支持团队：</p>
                  <ul>
                    <li>技术支持热线：400-888-9999</li>
                    <li>技术支持邮箱：support@greetec.com</li>
                    <li>工作时间：周一至周五 9:00-18:00</li>
                  </ul>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Support'
}
</script>

<style scoped lang="scss">
.support-content {
  margin-top: 30px;
  
  .faq-list {
    .faq-item {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;
      
      &:last-child {
        border-bottom: none;
      }
      
      .faq-question {
        h3 {
          margin-top: 0;
          margin-bottom: 15px;
          font-size: 18px;
          color: #1ebec8;
        }
      }
      
      .faq-answer {
        p {
          color: #666;
          margin: 0;
        }
      }
    }
  }
  
  .contact-support {
    p {
      margin-bottom: 15px;
    }
    
    ul {
      list-style: none;
      padding-left: 0;
      
      li {
        padding: 8px 0;
        color: #666;
      }
    }
  }
}
</style> 